import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OAuthModule } from 'angular-oauth2-oidc';
import { NgIdleModule } from '@ng-idle/core';
import { AppRoutingModule } from './app-routing.module';
import { authAppInitializerFactory } from './auth/auth-gaurd';
import { AuthService } from './auth/auth.service';
import { AppComponent } from './components/app/app.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { AppParams } from './shared/config/app.config';
import { CommonService } from './shared/config/common.service';
import { WebRequest } from './shared/config/web.request';
import { ApiInterceptorService } from './shared/interceptor/api-interceptor.service';
import { SharedPipesModule } from './shared/pipes/shared-pipes.module';

@NgModule({ declarations: [AppComponent, SignInComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        NgbModule,
        BrowserAnimationsModule,
        SharedPipesModule,
        NgIdleModule.forRoot(),
        OAuthModule.forRoot()], providers: [
        { provide: 'IWebRequest', useClass: WebRequest },
        { provide: 'IAppParams', useClass: AppParams },
        { provide: 'ICommonService', useClass: CommonService },
        provideAppInitializer(() => {
        const initializerFn = (authAppInitializerFactory)(inject(AuthService));
        return initializerFn();
      }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptorService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
